import { render, staticRenderFns } from "./PopUpComponent.vue?vue&type=template&id=5cf22585&scoped=true&"
import script from "./PopUpComponent.vue?vue&type=script&lang=js&"
export * from "./PopUpComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf22585",
  null
  
)

export default component.exports